export const DEFAULT_ELEMENT_OPTIONS: string[] = [
  'basic/icon-heart1',
  'basic/icon-star1',
  'basic/icon-sparkle',
  'basic/icon-diamond',
  'basic/icon-drop',
  'basic/icon-sun',
  'basic/icon-cloud',
];

export const ZODIAC_ELEMENT_OPTIONS: string[] = [
  'zodiac/icon-aries',
  'zodiac/icon-taurus',
  'zodiac/icon-gemini',
  'zodiac/icon-cancer',
  'zodiac/icon-leo',
  'zodiac/icon-virgo',
  'zodiac/icon-libra',
  'zodiac/icon-scorpio',
  'zodiac/icon-sagittarius',
  'zodiac/icon-capricorn',
  'zodiac/icon-aquarius',
  'zodiac/icon-pisces',
];
